import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation, Link } from "react-router-dom";
import { Toaster } from "sonner";
import ExperienceLayout from "@/experience/ExperienceLayout";
import ErrorBoundary from "@/experience/ErrorBoundary";
import BetaGate from "@/experience/BetaGate";
import ExperienceHome from "@/experience/pages/ExperienceHome";
import AskVeerGi from "@/experience/pages/AskVeerGi";
import BrandsPage from "@/experience/pages/BrandsPage";
import BrandPage from "@/experience/pages/BrandPage";
import LocationsPage from "@/experience/pages/LocationsPage";
import DishPage from "@/experience/pages/DishPage";
import Punjab from "@/experience/pages/Punjab";
import Passport from "@/experience/pages/Passport";
import QuizPage from "@/experience/pages/QuizPage";
import JourneyPage from "@/experience/pages/JourneyPage";
import MealBuilderPage from "@/experience/pages/MealBuilderPage";
import ArcadePage from "@/experience/pages/ArcadePage";
import CinematicDish from "@/experience/pages/CinematicDish";
import CustomPage from "@/experience/pages/CustomPage";
import StaffHub from "@/staff/StaffHub";
import { GoldLanding, GoldEntry, GoldMyEntries, GoldRules, GoldFreeEntry } from "@/gold/GoldApp";
import TableApp from "@/table/TableApp";
import LandingV2 from "@/landing/LandingV2";
import CatchTheNaan from "@/landing/CatchTheNaan";
import DarkMenu from "@/landing/DarkMenu";

const RedirectToMenu = () => {
  const location = useLocation();
  return <Navigate to={{ pathname: "/menu", search: location.search }} replace />;
};

// printed table QR codes target /menu?table=N — they now land straight on the /t ordering menu;
// without a table the guest menu at "/" takes over (old MenuPage stays in code, just routed around)
const TableAwareMenu = () => {
  const location = useLocation();
  const t = new URLSearchParams(location.search).get("table");
  if (t) return <Navigate to={`/t/${encodeURIComponent(t)}`} replace />;
  return <Navigate to="/" replace />;
};

const GiveawayBanner = () => (
  <Link to="/gold/rules" data-testid="giveaway-banner"
    style={{ display: "block", textAlign: "center", padding: "8px 12px", textDecoration: "none",
      background: "linear-gradient(100deg, #2a1a07, #3a2708 55%, #2a1a07)", borderBottom: "1.5px solid #D4AF37",
      color: "#F4A300", fontFamily: "Poppins, sans-serif", fontWeight: 700, fontSize: 12.5, lineHeight: 1.35 }}>
    Dine In, Win Gold. Order Online, Win Silver.{" "}
    <span style={{ textDecoration: "underline", color: "#D4AF37" }}>Rules</span>
  </Link>
);

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" theme="dark" richColors />
      <BrowserRouter>
        <ErrorBoundary>
          <BetaGate>
          <GiveawayBanner />
          <Routes>
          <Route path="/" element={<LandingV2 />} />
          <Route path="/naan" element={<CatchTheNaan />} />
          <Route path="/m" element={<DarkMenu />} />
          <Route path="/go/:screen" element={<TableApp noTable />} />
          <Route path="/staff" element={<StaffHub />} />
          <Route path="/staff/:tool" element={<StaffHub />} />
          <Route path="/gold" element={<GoldLanding />} />
          <Route path="/gold/rules" element={<GoldRules />} />
          <Route path="/gold/free-entry" element={<GoldFreeEntry />} />
          <Route path="/gold/my-entries" element={<GoldMyEntries />} />
          <Route path="/gold/e/:code" element={<GoldEntry />} />
          <Route path="/t" element={<TableApp />} />
          <Route path="/t/:table" element={<TableApp />} />
          <Route path="/t/:table/:screen" element={<TableApp />} />
          <Route path="/menu" element={<ExperienceLayout />}>
            <Route index element={<TableAwareMenu />} />
          </Route>
          <Route path="/p" element={<ExperienceLayout />}>
            <Route path=":slug" element={<CustomPage />} />
          </Route>
          <Route path="/experience" element={<ExperienceLayout />}>
            <Route index element={<Navigate to="/" replace />} />
            <Route path="home" element={<ExperienceHome />} />
            <Route path="veergi" element={<AskVeerGi />} />
            <Route path="brands" element={<BrandsPage />} />
            <Route path="brands/:key" element={<BrandPage />} />
            <Route path="explore" element={<RedirectToMenu />} />
            <Route path="menu" element={<RedirectToMenu />} />
            <Route path="order" element={<RedirectToMenu />} />
            <Route path="dish/:slug" element={<DishPage />} />
            <Route path="cinematic/:slug" element={<CinematicDish />} />
            <Route path="punjab" element={<Punjab />} />
            <Route path="passport" element={<Passport />} />
            <Route path="quiz" element={<QuizPage />} />
            <Route path="journey/:slug" element={<JourneyPage />} />
            <Route path="meal" element={<MealBuilderPage />} />
            <Route path="arcade" element={<ArcadePage />} />
            <Route path="locations" element={<LocationsPage />} />
            <Route path="admin" element={<Navigate to="/staff/admin" replace />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </BetaGate>
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
}

export default App;
